import { StaticFormFieldMappings } from '../../../service-request-form-response.mapper.util';
import { HI_HOSE_INSTANCE_FIELD_KEYS } from './hi-form.fields';

const HI_HOSE_BASE_QUESTION_ID = 99501;

export const HI_STATIC_FIELD_MAPPINGS: StaticFormFieldMappings = {
  siteContactName: 99101,
  bulkPlant: 99102,
  plantAddress: 99103,
  plantCoordinates: 99104,
  ownership: 99105,
  vesselSerialNo: 99106,
  ...Object.fromEntries(
    HI_HOSE_INSTANCE_FIELD_KEYS.map((controlKey, index) => [controlKey, HI_HOSE_BASE_QUESTION_ID + index]),
  ),
  signOffComments: 99518,
  actionTaken: 99519,
  inspectionNo: 99520,
  inspectionType: 99521,
  inspectionDate: 99522,
  inspectionOutcome: 99523,
  outcomeRemarks: 99524,
  technicianComments: 99525,
};
